import { useState } from 'react';

export interface IUseBookingLinkSelection {
  selectedBookingLinkId: string | null;
  selectBookingLink: (bookingLinkId: string | null) => void;
  resetBookingLink: () => void;
}

export const useBookingLinkSelection = (): IUseBookingLinkSelection => {
  const [selectedBookingLinkId, setSelectedBookingLinkId] = useState<
    string | null
  >(null);

  const selectBookingLink = (bookingLinkId: string | null): void => {
    setSelectedBookingLinkId(bookingLinkId);
  };

  const resetBookingLink = (): void => {
    setSelectedBookingLinkId(null);
  };

  return { selectedBookingLinkId, selectBookingLink, resetBookingLink };
};
